import React, {useContext, useState} from 'react';
import './Editable.css';
import '../../App/Styles.css'
import {Editable, EditableProps} from "./Editable";
import {EditableContext, useEditable} from "./EditableContext";
import {setValueForStyles} from "@vis.gl/react-google-maps/dist/libraries/set-value-for-styles";

type Props<EnclosingType extends object> = EditableProps<EnclosingType, string> & {
  suggestions: string[],
}

export const EditableStringFieldWithSuggestions = <EnclosingType extends object>(props: Props<EnclosingType>) => {

  const {value, setValue, editing} = useEditable(props)
  
  const [focused, setFocused] = useState(false);

  return <Editable {...props}>
    {editing && <>
      <input className={'EditableEditing'} type={'text'}
             onFocus={() => setFocused(true)}
             onBlur={() => {
               // Keeps the blur from happening before a click on an item.
               setTimeout(() => setFocused(false), 100);
             }}
             value={value ?? ''}
             onChange={event => setValue(event?.target.value)}/>

      {/* this div is an anchor for the relatively positioned overlay*/}
      <div style={{position: "relative"}}>
        {props.suggestions && focused && <div className={'EditableSuggestionOverlay'}>
          {props.suggestions.map((suggestion, index) => {
            return <div key={'s' + index} className={'EditableSuggestion'} onClick={() => {
              console.log('uhhh', suggestion)
              setValue(suggestion);
            }}>{suggestion}</div>
          })}
        </div>}
      </div>
    </>}

    {!editing && <div className={'EditableNotEditing'}>{value}</div>}
  </Editable>

}